import React, { useState, useCallback, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { MqDesktop } from 'streamr-ui/css/consts'
import { useInViewport } from 'streamr-ui/hooks'

const Root = styled.div`
    opacity: 0;
    transition-delay: 0s, 0.2s;
    transition-property: opacity, visibility;
    transition: 0.3s ease-in-out;
    visibility: hidden;

    ${({ active }) =>
        !!active &&
        css`
            opacity: 1;
            transition-delay: 0.3s, 0s;
            visibility: visible;
        `}
`

const UnstyledIndexLabel = ({ active: activeProp, current, total, className }) => {
    const [ref, inViewport] = useInViewport()

    const finalActive = !!activeProp && !!inViewport

    const [active, setActive] = useState(finalActive)

    const hide = useCallback(() => {
        setActive(false)
    }, [])

    useEffect(() => {
        hide()
    }, [hide])

    useEffect(() => {
        if (active !== finalActive) {
            setActive(finalActive)
        }
    }, [active, finalActive])

    return (
        <Root className={className} active={active}>
            <span ref={ref}>{`${current} of ${total}`}</span>
        </Root>
    )
}

const IndexLabel = styled(UnstyledIndexLabel)`
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 1em;
    color: white;
    font-size: 10px;
    line-height: 2em;
    padding: 0 1em;

    @media ${MqDesktop} {
        font-size: 12px;
    }
`

export default IndexLabel
